import { render, staticRenderFns } from "./JobGotten.vue?vue&type=template&id=bff6e28e&scoped=true&"
import script from "./JobGotten.vue?vue&type=script&lang=js&"
export * from "./JobGotten.vue?vue&type=script&lang=js&"
import style0 from "./JobGotten.vue?vue&type=style&index=0&id=bff6e28e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff6e28e",
  null
  
)

export default component.exports